import React from 'react'

import { getRegionCoefficientsHandbook } from 'services/apiRequests'

import { useDispatch } from 'react-redux'
import { setDirectoryItems, setId, setVersionId } from 'store/directorySlice'

const useGetRegionCoefficients = (requestData: boolean | undefined) => {
  const dispatch = useDispatch()

  const tryToGetOffsets = async () => {
    await getRegionCoefficientsHandbook().then((res) => {
      dispatch(setId(res.data.id))
      dispatch(setVersionId(res.data.id))
      dispatch(
        setDirectoryItems(
          res.data.regions_coefficients.map((unit) => {
            return {
              ...unit,
              modified: false,
            }
          }),
        ),
      )
    })
  }

  React.useEffect(() => {
    tryToGetOffsets().then()
  }, [requestData])

  return
}

export default useGetRegionCoefficients
